import { getBackendLanguageFromAppLocale } from './language-map';
import { getGuestLocaleFromStorage } from './resolve-locale';
import { DEFAULT_LOCALE, isSupportedLocale } from './constants';

var runtimeBackendLanguage = getBackendLanguageFromAppLocale(DEFAULT_LOCALE);

export function syncAjaxLanguageHeader(appLocale) {
  runtimeBackendLanguage = getBackendLanguageFromAppLocale(appLocale);
}

export function getRequestLanguageHeader() {
  return runtimeBackendLanguage;
}

export function resolveBackendLanguageForRequest() {
  try {
    if (typeof window !== 'undefined' && window.vbus && window.vbus.$i18n) {
      var current = window.vbus.$i18n.locale;
      if (isSupportedLocale(current)) {
        return getBackendLanguageFromAppLocale(current);
      }
    }
  } catch (e) {
    // vbus may be unavailable during early bootstrap
  }
  var guest = getGuestLocaleFromStorage();
  if (guest) {
    return getBackendLanguageFromAppLocale(guest);
  }
  return runtimeBackendLanguage;
}
